/* import __COLOCATED_TEMPLATE__ from './account-row.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { bool } from '@ember/object/computed';
import { inject as service } from '@ember/service';
let AccountRow = (_dec = service('bbfrontend/v1/withholding-config'), _dec2 = bool('account.withholdingEnabled'), _dec3 = bool('account.targetCompletedAt'), _dec4 = bool('account.targetAmount'), _class = class AccountRow extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "bbFrontendV1WithholdingConfigService", _descriptor, this);
    _defineProperty(this, "account", void 0);
    _initializerDefineProperty(this, "isWithholding", _descriptor2, this);
    _initializerDefineProperty(this, "isTargetComplete", _descriptor3, this);
    _initializerDefineProperty(this, "hasTarget", _descriptor4, this);
  }
  get hasEnabledUnitWithholding() {
    return Boolean(this.account.unitWithholdingConfigs?.some(c => c.isEnabled));
  }
  get withholdingBps() {
    if (this.hasEnabledUnitWithholding) {
      return this.account.maxUnitWithholdingBps;
    } else {
      return this.account.withholdingBps;
    }
  }
  get accountWithholdingConfig() {
    return this.bbFrontendV1WithholdingConfigService.accountWithholdingConfigs.find(aWC => aWC.accountId === this.account.id);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1WithholdingConfigService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isWithholding", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isTargetComplete", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasTarget", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { AccountRow as default };